var map = {
	"./about.md": 6788,
	"./config": 7782,
	"./config.json": 7782,
	"./links": 8729,
	"./links.json": 8729,
	"./posts": 5607,
	"./posts.json": 5607,
	"./project-des.md": 2645,
	"./projects": 3794,
	"./projects.json": 3794
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7111;